import { AnswerStatus } from "@/models/enum/answerStatus";

export class AnswerSetDto {
  questionSetId: string = "";
  contextId: string = "";
  contextIds: string[] = [];
  answerStatus: AnswerStatus = AnswerStatus.NotStarted;
  answers: AnswerDto = {};
  submitWithNonCompletedAnswers: boolean = false;
}

export interface AnswerDto {
  [key: string]: object; // Key: QuestionId, Value: Answer
}